/**
 * User: Rob Richard
 * Date: 9/24/14
 * Time: 5:43 PM
 */

'use strict';

const get = require('lodash.get');
const moment = require('moment');
const helpers = require('./checkout-helpers.es');
const redirects = require('./checkout-redirects.es');
const userHelpers = require('./checkout-user.es');
const { GA_BOOLEANS, GA_FRAGMENT } = require('../models/CheckoutGAConstants.es');
const {constants: authConstants} = require('../../auth/authModalLoader').default;

const getYesNoType = condition => (condition ? GA_BOOLEANS.BOOLEAN_YES : GA_BOOLEANS.BOOLEAN_NO);
const getGAFragment = (prefix, val) => `${prefix}=${val}`;
const getYesNoGAFragment = (prefix, condition) => `${prefix}=${getYesNoType(condition)}`;

const trackHelpers = module.exports = {

    _getCheckoutTriggerFromQueryParam() {
        let trigger = redirects.getParamFromUrl('checkout_trigger');

        if (redirects.isUserComesFromEmail()) {
            trigger = 'email';
        } else if (redirects.isUserComesFromAcceptedOffer()) {
            if (this.getCheckoutTriggerFromReferrer() === 'message center') {
                trigger = 'message center';
            } else {
                trigger = 'my orders';
            }
        }
        return trigger;
    },
    getGAVerificationObj(interaction) {
        return {
            category: authConstants.LOGIN,
            action: `verification ${interaction}`,
            label: 'before checkout page'
        };
    },
    getGATransactionType() {
        return helpers.isNegotiable() ? 'make offer' : 'purchase';
    },
    getCheckoutTriggerFromReferrer() {
        const referrer = document.referrer;
        let trigger;

        if (referrer.indexOf('favorites') > -1) {
            trigger = 'favorites';
        } else if (referrer.indexOf('conversations') > -1) {
            trigger = 'message center';
        } else if (referrer.indexOf('cart') > -1) {
            trigger = 'cart';
        } else if (referrer.indexOf('id-') > -1 && referrer.indexOf('checkout') === -1) {
            trigger = 'pdp';
        }
        return trigger;
    },
    getCheckoutTrigger() {
        return trackHelpers._getCheckoutTriggerFromQueryParam() || trackHelpers.getCheckoutTriggerFromReferrer();
    },
    getPostingLocation(item) {
        if (get(item, 'isNewListing')) {
            return 'New Listings';
        } else if (get(item, 'isPublishedMarketplace')) {
            return 'Marketplace';
        } else if (get(item, 'isPublishedStorefront')) {
            return 'Storefront';
        }
        return '';
    },
    getPurchaseStatus(item) {
        return [
            getYesNoGAFragment(GA_FRAGMENT.FRAGMENT_PURCHASABLE, get(item, 'isAvailable')),
            getYesNoGAFragment(GA_FRAGMENT.FRAGMENT_NEGOTIABLE, get(item, 'pricing.negotiable')),
            getYesNoGAFragment(GA_FRAGMENT.FRAGMENT_RETURNABLE, get(item, 'returnPolicy.accept'))
        ].join('|');
    },
    getClassification(item) {
        const categories = get(item, 'classification.categories', []);
        return get(categories[0], 'category.name');
    },
    getClassifications(item) {
        const categories = get(item, 'classification.categories', []);
        const names = [];
        categories.forEach(c => names.push(get(c, 'name')));
        return names.join('/');
    },
    formatDate(unixDate) {
        const date = new Date(unixDate);
        return moment(date).format('MM-DD-YYYY');
    },
    getCallToAction() {
        if (helpers.isNegotiable()) {
            return 'make offer';
        } else if (redirects.getParamFromUrl('fullPrice') === 'true') {
            return 'purchase at full price';
        } else if (redirects.isUserComesFromAcceptedOffer()) {
            return 'accept offer';
        } else {
            return 'purchase';
        }
    },
    getAdditionalEmbeddedRegistrationGTM(buyer) {
        const isVIPBuyer = get(buyer, 'isVip');
        const canUseNetPrice = get(buyer, 'canUseNetPrice');
        let customerType;

        if (canUseNetPrice && isVIPBuyer) {
            customerType = 'Trade and VIP';
        } else if (canUseNetPrice) {
            customerType = 'Trade';
        } else if (isVIPBuyer) {
            customerType = 'VIP';
        } else {
            customerType = 'Consumer';
        }
        return {
            userID: userHelpers.getUserId(),
            loginStatus: 'Logged In',
            registrationStatus: 'Registered',
            customerType
        };
    },
    getItemLargePhotosCount(item) {
        const photos = get(item, 'photos');
        let count = 0;

        photos.forEach(photo => {
            const versions = get(photo, 'versions');
            const hasLargeVersion = !!(versions.filter(v => get(v, 'type.name') === 'large' && get(v, 'webPath')).length);
            if (hasLargeVersion) {
                ++count;
            }
        });
        return count;
    },
    getItemDates(item) {
        const releaseDate = get(item, 'releaseDate');
        const soldDate = 'none';
        const released = releaseDate && trackHelpers.formatDate(releaseDate) || 'none';
        return [
            getGAFragment(GA_FRAGMENT.FRAGMENT_RELEASED_DATE, released),
            getGAFragment(GA_FRAGMENT.FRAGMENT_SOLD_DATE, soldDate)
        ].join('|');
    },
    getOrderType() {
        if (helpers.isPrivateOffer()) {
            return 'private offer';
        } else if (helpers.isNegotiable()) {
            return 'negotiated';
        } else {
            return 'full price';
        }
    },
    getPriceType(item, buyer) {
        if (get(item, 'isSaturdaySale')) {
            return "saturday sale";
        } else if (get(buyer, 'isVerifiedTrade') && get(item, 'hasNetPrice')) {
            return "net price";
        } else if (get(item, 'isPriceUponRequest') && helpers.isPrivateOffer()) {
            return "price upon request";
        } else {
            return "list price";
        }
    },
    getItemProducts(item, transaction) {
        const offer = get(transaction, 'mostRecentOffer');
        return {
            id: get(item, 'serviceId'),
            name: get(item, 'title'),
            brand: get(item, 'seller.serviceId'),
            category: get(item, 'classification.categories[0].category.browseUrl'),
            price: get(offer, 'amountPerItem.convertedAmounts.USD'),
            quantity: get(offer, 'quantity')
        };
    }
};




// WEBPACK FOOTER //
// ./assets/js/checkout/helpers/checkout-track-helpers.es.js